import { render, staticRenderFns } from "./BaseTLCheckBox.vue?vue&type=template&id=35c00cc9&"
import script from "./BaseTLCheckBox.vue?vue&type=script&lang=ts&"
export * from "./BaseTLCheckBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports